export enum Status {
  DONE = 'done',
  DENIED = 'denied',
  WAIVER = 'waiver',
  INITIAL = 'initial',
  CURRENT = 'current'
}
